/**
 * The invite link's token (GRO-106 design, "Invite link page"). It arrives in the fragment
 * of `/invite#<token>`, is held in `sessionStorage` until the invite flow ends, and the
 * fragment is removed from the address bar at once. A reload in the middle of the flow,
 * and the Google sign-in round trip, keep it. Every storage access is wrapped: without
 * storage the token lives only as long as this page.
 */
const KEY = 'grovus.inviteToken'
export const INVITE_PATH = '/invite'

let memory: string | null = null

/** On `/invite#<token>`: stores the token and replaces the URL with `/invite`. */
export function captureInviteToken() {
  if (window.location.pathname !== INVITE_PATH) return
  const token = window.location.hash.replace(/^#/, '')
  if (token === '') return
  try {
    sessionStorage.setItem(KEY, token)
  } catch {
    // No storage: the token is held in memory for this page only.
    memory = token
  }
  window.history.replaceState(null, '', INVITE_PATH)
}

export function heldInviteToken(): string | null {
  try {
    return sessionStorage.getItem(KEY)
  } catch {
    return memory
  }
}

export function clearInviteToken() {
  memory = null
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing stored.
  }
}
